import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const WrapperAutocomplete = styled.div`
  width: 100%;

  .MuiInputBase-root.MuiInput-root input.MuiAutocomplete-input {
    font-family: AllianceNo2-SemiBold;
    font-weight: 100;
    color: var(--title-color) !important;

    &::placeholder {
    color: var(--Text-Primary) !important;
    opacity:0.6;
    }
  }

  .MuiAutocomplete-popper {
    * {
      font-family: AllianceNo2-SemiBold;
      font-weight: 100;
      color: var(--Text-Primary);
    }
  }

  .MuiAutocomplete-endAdornment button {
    padding: 5px 0 !important;
    margin: 0px !important;
    color: var(--Text-Primary) !important;

    &:hover {
      background: transparent;
    }
  }

  .MuiAutocomplete-root .MuiChip-root {
    height: 20px;
    background-color: var(--mui-chip-background);
    span {
      font-family: AllianceNo2-SemiBold;
      font-weight: 100;
      color: var(--Text-Primary);
    }
    svg.MuiChip-deleteIcon {
      font-size: 16px;
      color: var(--mui-chip-delete-icon);
      opacity:0.4;
    }
  }
`;

const IconContainer = styled.div`
  font-family: AllianceNo2-SemiBold;
  font-weight: 100;
  padding-right: 10px;

  i {
    font-size: 18px;
    color: var(--Text-Primary);
  }
`;

const SelectMultiAutocomplete = ({
  className = "",
  disabled = false,
  icon = null,
  name = "",
  title = "",
  options,
  placeholder='',
  selected = null,
  onChange
}) => {
  const [value, setValue] = useState([]);
  // The caller that keeps the selection gives the values selected, which are
  // shown as the options of the list holding them. The selection shown is the
  // one of the component when the caller keeps none.
  const selection =
    selected === null
      ? value
      : options.filter((option) => selected.includes(option.value));

  return (
    <Wrapper className={`${className}`}>
      {icon ? (
        <IconContainer title={title || name}>
          <i className="material-icons">{icon}</i>
        </IconContainer>
      ) : null}
      <WrapperAutocomplete>
        <Autocomplete
          multiple
          id="tags-standard"
          options={options}
          onChange={(event, newValue) => {
            if (newValue !== null) {
              setValue(newValue);
              onChange(newValue);
            }
          }}
          className={className}
          getOptionLabel={(option) => option.label}
          value={selection}
          filterSelectedOptions={true}
          disablePortal
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label=""
              placeholder={placeholder}
            />
          )}
        />
      </WrapperAutocomplete>
    </Wrapper>
  );
};

export default SelectMultiAutocomplete;
